import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ServicePage from "./pages/ServicePage";
import ServicePageNew from "./pages/ServicePageNew";
import AboutUs from "./pages/AboutUs";
import Blog from "./pages/Blog";
import SingleBlog from "./pages/SingleBlog";
import Contact from "./pages/Contact";

// Import individual "Other Services" pages
import BookVideoTrailer from "./pages/services/BookVideoTrailer";
import WebDesignSEO from "./pages/services/WebDesignSEO";
import IllustrationServices from "./pages/services/IllustrationServices";
import ArticlesServices from "./pages/services/ArticlesServices";
import BookDesignServices from "./pages/services/BookDesignServices";
import BlogWritingServices from "./pages/services/BlogWritingServices";
import WebContentWriting from "./pages/services/WebContentWriting";

// Import Landing Pages
import BookWritingLP from "./pages/BookWritingLP";
import BookPublishingLP from "./pages/BookPublishingLP";
import BookMarketingLP from "./pages/BookMarketingLP";
import AudiobookLP from "./pages/AudiobookLP";
import BookEditingLP from "./pages/BookEditingLP";
import BookDesignLP from "./pages/BookDesignLP";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import ThankYou from "./pages/ThankYou";
import SignupThankYou from "./pages/SignupThankYou";

// Layout wrapper component to conditionally render header and footer
function Layout() {
  const location = useLocation();
  const isLandingPage = location.pathname.startsWith("/lp/");
  const isSignupThankYou = location.pathname === "/signup-thankyou" || location.pathname === "/thank-you-success";
  const isThankYouPage = location.pathname === "/thank-you";

  return (
    <>
      {!isLandingPage && !isSignupThankYou && !isThankYouPage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<SingleBlog />} />
        <Route path="/contact" element={<Contact />} />
        
        {/* Individual "Other Services" pages */}
        <Route path="/services/book-video-trailer" element={<BookVideoTrailer />} />
        <Route path="/services/web-design-seo" element={<WebDesignSEO />} />
        <Route path="/services/illustration-services" element={<IllustrationServices />} />
        <Route path="/services/articles-services" element={<ArticlesServices />} />
        <Route path="/services/book-design-services" element={<BookDesignServices />} />
        <Route path="/services/blog-writing-services" element={<BlogWritingServices />} />
        <Route path="/services/web-content-writing" element={<WebContentWriting />} />
        
        {/* Landing Pages */}
        <Route path="/lp/book-writing/" element={<BookWritingLP />} />
        <Route path="/lp/book-publishing/" element={<BookPublishingLP />} />
        <Route path="/lp/book-marketing/" element={<BookMarketingLP />} />
        <Route path="/lp/audiobook-production/" element={<AudiobookLP />} />
        <Route path="/lp/book-editing/" element={<BookEditingLP />} />
        <Route path="/lp/book-design/" element={<BookDesignLP />} />
        
        {/* Thank You Pages - MUST be before wildcard routes */}
        <Route path="/thank-you-success" element={<SignupThankYou />} />
        <Route path="/signup-thankyou" element={<SignupThankYou />} />
        <Route path="/thank-you" element={<ThankYou />} />
        
        {/* Legal Pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        
        {/* All other service pages use ServicePage component */}
        <Route path="/services/:slug" element={<ServicePage />} />
      </Routes>
      {!isLandingPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
